import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { EmitterService } from '../../../services/emitter.service';
import { CreditCardService } from '../../services/credit-card.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CardService } from '../../../dynamic-form-builder/services/card.service';
import { Utility } from '../../../shared/utility/utility';
import { UserDetailsService } from '../../../services/user-details.service';
import { CashierService } from '../../services/cashier.service';

@Component({
  selector: 'app-saved-cards',
  templateUrl: './saved-cards.component.html',
  styleUrls: ['./saved-cards.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class SavedCardsComponent implements OnInit {

  selectedCard;
  isShowList = false;
  isAddNewButtonClicked = false;
  @Input() selectedPaymentMethod = null;
  cardsData =  [];
  savedCardForm:FormGroup;
  isSubmitted = false;
  transactionMessage = "";
  isOnBlur=false;
  validationClass='';
  isBelowe_480 = false;
  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.isBelowe_480 = this.utils.isDeviceBelowe_480();
}
  constructor(private emitterService:EmitterService, private creditCardService:CreditCardService, 
    private userDetailsService:UserDetailsService,
    private fb:FormBuilder, private cardService:CardService, private utils:Utility, private cashierService:CashierService) { 
    this.emitterService.onChangePaymentMethod$.subscribe((newMethod:any) => {
      this.resetErrorFormDetails();
       this.cardsData = newMethod?.accounts ? newMethod?.accounts : [];
       this.cardsData = this.cardsData.filter((item)=> !item?.isDeleted);
       this.selectedPaymentMethod = newMethod;
    });
    this.savedCardForm = this.fb.group({
      cardCvv:['', this.cardService.checkCvvValidation(3,3)],
      name:['',Validators.required],
      expiryMonth:['',Validators.required],
      expiryYear:['',Validators.required],
      accountId:['',Validators.required]
    })
  }

 
  ngOnInit(): void {
    this.isBelowe_480 = this.utils.isDeviceBelowe_480();
    this.cardsData = this.selectedPaymentMethod?.accounts ?  this.selectedPaymentMethod?.accounts : [];
    this.cardsData = this.cardsData.filter((item)=> !item?.isDeleted);
    this.selectedPaymentMethod =  this.selectedPaymentMethod;
    this.emitterService.emitSubmitFormClick$.subscribe((status)=>{
      if(this.selectedCard){
        this.isSubmitted = true;
        this.getErrorMessage();
        
      }
    });
    
  }
  checkErrorValidation(){
    if(!this.savedCardForm.controls['cardCvv'].value){
      return;
    }
    this.isOnBlur = true;
    this.getIsValidClass()
    return this.utils.shouldShowErrors('cardCvv', this.savedCardForm);
  }
  getErrorMessage() {
    this.transactionMessage = this.utils.getErrorMessage('cardCvv', this.savedCardForm);
    this.getIsValidClass()
  }
  showListOfCards(){
    this.isShowList = !this.isShowList;
  }
  removedClicked(event,card){
    event.stopPropagation();
    card.isEditEnabled = !card.isEditEnabled
  }
  deleteCard(card){
    let userId = this.userDetailsService?.userProfileDetails?.playerID;
    let sessionId = this.cashierService?.tokenData?.token
    
    
    this.creditCardService.deletSavedCard(userId,card.accountId,sessionId).subscribe((deleteCardResponse)=>{
      if(deleteCardResponse['success']){
        card.isDeleted = true;
        if(this.selectedCard?.accountId == card.accountId){
           this.selectedCard = null; 
        }
        this.cardsData = this.cardsData.filter((item)=> !item?.isDeleted);
        if(!this.cardsData?.length){
          this.emitterService.broadCastAddNewCardClick(true);
          this.isAddNewButtonClicked = false;
        }
        console.log(this.cardsData)
      }
    })
  }
  updateCard(e,card){ 
    if(this.selectedCard != card){
      e.stopPropagation();
      this.savedCardForm.controls['cardCvv'].setValue('');
      this.isShowList = false;
      this.selectedCard = card;
      this.isAddNewButtonClicked = false;
      this.validationClass = '';
      this.emitterService.broadCastAddNewCardClick(false);
      //updating form
      let expiryDate = card.expiryDate.split('-');
      if(expiryDate?.length == 2){
        let {0:expiryYear, 1:expiryMonth} =  expiryDate;
        this.savedCardForm.controls['expiryMonth'].setValue(expiryMonth);
        this.savedCardForm.controls['expiryYear'].setValue(expiryYear);
        this.savedCardForm.controls['accountId'].setValue(card?.accountId);
        this.savedCardForm.controls['name'].setValue(card?.cardHolder);
      }
     this.resetErrorFormDetails();
     this.emitterService.broadCastFormValidationStatus(true);
     this.emitterService.broadCastCreditCardFormData(this.savedCardForm);
    }else{
      this.isShowList = false;
    }
  }
  resetErrorFormDetails(){
    this.transactionMessage = "";
    this.isOnBlur = false;
    this.isSubmitted = false;
  }
  addNewCard(){
    this.isAddNewButtonClicked = true;
    this.selectedCard = null;
    this.isShowList = false;
    this.emitterService.broadCastAddNewCardClick(true);
  }
  checkLengthOfTheElement(event){
    if(event.target.value.length>=3 && (event.keyCode >= 48 && event.keyCode <=57)){
       event.preventDefault();
    }
  }
  getIsValidClass(){
    this.validationClass = !this.isOnBlur && !this.isSubmitted ? "" : this.transactionMessage  ? 'field-invalid' : 'field-valid'
  }
}
